import { DefaultCarPageComponentProps } from "@/app/interface/components";
import ContactForm from "../../ContactForm/ContactForm";
import CarOverview from "./CarOverview";
import TechSpecs from "./TechSpecs";
import CarRotation from "./CarRotation";

const CarDatasheet: React.FC<
  DefaultCarPageComponentProps & { spriteUrl: string }
> = ({
  car,
  model,
  version,
  color,
  setModel,
  setVersion,
  setColor,
  spriteUrl,
}) => {
  if (!car) {
    return null; // ou um componente de loading/erro
  }

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <main className="flex flex-col bg-neutral-100 w-full items-center">
        <div className="w-fit h-fit right-0 top-48 my-10 ml-96 sticky z-[22]">
          <ContactForm options={model?.versions?.map((v) => v.name)} />
        </div>
        <section className="flex relative z-[21] -mt-[700px] pb-40 px-20 overflow-hidden max-w-[1140px] mx-auto justify-start w-full">
          <div>
            <CarOverview
              car={car}
              model={model}
              version={version}
              color={color}
              setModel={setModel}
              setVersion={setVersion}
              setColor={setColor}
            />
          </div>
        </section>
        <TechSpecs
          car={car}
          model={model}
          version={version}
          color={color}
          setModel={setModel}
          setVersion={setVersion}
          setColor={setColor}
        />
      </main>
    </div>
  );
};

export default CarDatasheet;
